module.exports = __webpack_public_path__ + "static/logos/sf_logo--white-2589b0b51ec912428e712d207a2b4a26.svg";